const initialState = {
    isFetching: null,
    isError: false,
    result: { content: { data: [], page: 1, totalCount: 0 }, status: true },
  };
  
  export const SETTING_LABEL_FETCHING = 'SETTING_LABEL_FETCHING';
  export const SETTING_LABEL_FAILED = 'SETTING_LABEL_FAILED';
  export const SETTING_LABEL_SUCCESS = 'SETTING_LABEL_SUCCESS';
  export const SettingLabelReducer = (
    state = initialState,
    { type, payload }
  ) => {
    switch (type) {
      case SETTING_LABEL_FETCHING:
        return { ...state, isFetching: true, isError: false };
      case SETTING_LABEL_FAILED:
        return {
          ...state,
          isFetching: false,
          isError: true,
          result: { content: { data: [], page: 1, totalCount: 0 }},
        };
      case SETTING_LABEL_SUCCESS:
        return { ...state, isFetching: false, isError: false, result: payload };
      default:
        return state;
    }
  };
  
  export const SETTING_LABEL_DELETE_FETCHING = 'SETTING_LABEL_DELETE_FETCHING';
  export const SETTING_LABEL_DELETE_FAILED = 'SETTING_LABEL_DELETE_FAILED';
  export const SETTING_LABEL_DELETE_SUCCESS = 'SETTING_LABEL_DELETE_SUCCESS';
  export const SettingLabelDeleteReducer = (
    state = initialState,
    { type, payload }
  ) => {
    switch (type) {
      case SETTING_LABEL_DELETE_FETCHING:
        return { ...state, isFetching: true, isError: false };
      case SETTING_LABEL_DELETE_FAILED:
        return {
          ...state,
          isFetching: false,
          isError: true,
          result: { content: { data: [], page: 1, totalCount: 0 }},
        };
      case SETTING_LABEL_DELETE_SUCCESS:
        return { ...state, isFetching: false, isError: false, result: payload };
      default:
        return state;
    }
  };
  